import React, { FC, useState } from 'react'
import './PensionUpdate.scss'

import { useForm } from 'react-hook-form'

import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import { ShowTGAlert } from 'Helpers/ShowTGAlert'
import employeeService from 'Services/employeeService'

interface propsType {
  toggleModal: () => void
}

export type pensionUpdate = {
  pfa: string
  rsaNumber: string
}

const schema = yup.object().shape({
  pfa: yup.string().required('Field is required'),
  rsaNumber: yup.string().required('Field is required'),
})

const PensionUpdate: FC<propsType> = ({ toggleModal }) => {
  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm<pensionUpdate>({
    resolver: yupResolver(schema),
  })

  const { showAlert } = ShowTGAlert()
  const [request, setRequest] = useState(false)

  const submitNewUserInformation = handleSubmit(async (data: pensionUpdate) => {
    // await employeeService.createNew(data).then(
    //   () => {
    //     setRequest(false)
    //     toggleModal()
    //     showAlert({
    //       message: 'Pension Details updated successfully',
    //       show: true,
    //       title: 'Success',
    //       type: 'success',
    //     })
    //     setTimeout(() => {
    //       window.location.reload()
    //     }, 200)
    //   },
    //   (error: { response: { data: { error: string } } }) => {
    //     setRequest(false)
    //     toggleModal()
    //     showAlert({
    //       message: error.response.data.error,
    //       show: true,
    //       title: 'Error',
    //       type: 'error',
    //     })
    //   },
    // )
  })
  return (
    <div className='pension-update'>
      <form action='/product-scanner'>
        <div className='form-group mb-3'>
          <label htmlFor='pfa'>PFA</label>
          <select id='pfa' defaultValue='' className='form-control' {...register('pfa')}>
            <option disabled value=''>
              --Select PFA--
            </option>
            <option value='ibtc'>Stanbic IBTC Pension Managers</option>
            <option value='tp'>Trustfund Pensions Plc</option>
            <option value='ppl'>Premium Pension Limited</option>
          </select>
          {errors.pfa && <div className='text-danger'>{errors.pfa.message}</div>}
        </div>

        <div className='form-group mb-3'>
          <label htmlFor='price-per-lit'>RSA Number</label>
          <input
            placeholder='RSA Number'
            type='text'
            id='rsaNumber'
            className='form-control'
            {...register('rsaNumber')}
          />
          {errors.rsaNumber && <div className='text-danger'>{errors.rsaNumber.message}</div>}
        </div>

        <div className='form-group'>
          <button
            className='btn btn-default-2 w-100'
            onClick={(e) => submitNewUserInformation(e)}
            disabled={request}
          >
            Save Details {request && <span className='spinner-border spinner-border-sm'></span>}
          </button>
        </div>
      </form>
    </div>
  )
}

export default PensionUpdate
